export default __webpack_public_path__ + "static/ebba-5cd6b4e28e2896d5f18e3b7400eed433.png";